import { render, staticRenderFns } from "./DxDetailTabProduct.vue?vue&type=template&id=0b643bc7&"
import script from "./DxDetailTabProduct.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports